import React from 'react'
import {Card} from 'src/app/components/Libs'

const GuestWrapper: React.FC<{withTitle?: boolean; children?: React.ReactNode}> = ({
  withTitle = true,
  children,
}) => {
  return (
    <div className='relative flex items-center justify-center w-screen h-screen py-24 bg-neutral-50 drop-shadow-sm'>
      <div className='absolute bottom-0 left-0'>
        <img src='/media/image/dots_pattern.svg' alt='pattern' />
      </div>
      <div className='h-max-[688px] w-[444px] z-[10]'>
        <Card.Root className='flex justify-between h-full py-[44px] px-8 rounded-lg'>
          <div className=''>{children}</div>
        </Card.Root>
      </div>
    </div>
  )
}

export default GuestWrapper
